import { CustomFieldType } from './custom-field-type.enum';
export var isMultilevelCustomField = function (customField) { return customField.type === CustomFieldType.MULTI_LEVEL; };
export var notMultilevelCustomField = function (customField) { return customField.type !== CustomFieldType.MULTI_LEVEL; };
//# sourceMappingURL=custom-field.i.js.map